import {
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  Tooltip,
  Typography,
} from "@mui/material";
import { HelpOutline } from "@mui/icons-material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { hostname } from "../../utils";

export default ({
  actionParameters,
  setActionParameters,
  companyId,
  getToken,
  setValidForm,
  listId,
}: {
  actionParameters: any;
  setActionParameters: (p: any) => void;
  companyId: string;
  getToken: Function;
  setValidForm: (b: boolean) => void;
  listId: string;
}) => {
  const [lists, setLists] = useState<Array<any>>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Initialize with defaults
    if (actionParameters.targetListId === undefined) {
      setActionParameters({
        ...actionParameters,
        targetListId: "",
        removeFromCurrent: false,
      });
    }
  }, []);

  useEffect(() => {
    // Validate form
    setValidForm(
      actionParameters.targetListId && 
      actionParameters.targetListId !== ""
    );
  }, [actionParameters.targetListId]);

  useEffect(() => {
    // Fetch available lists
    const fetchLists = async () => {
      setLoading(true);
      try {
        const currentToken = await getToken();
        const response = await axios.get(
          `${hostname}/lists?companyId=${companyId}&page=1&pageSize=100&minimal=true`,
          {
            headers: { Authorization: `Bearer ${currentToken}` },
          }
        );
        setLists(response.data.items || []);
      } catch (error) {
        console.error("Error fetching lists:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchLists();
  }, [companyId, getToken]);

  return (
    <div>
      <div style={{ marginTop: "16px" }}>
        <Typography variant="subtitle1" sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
          Target List
          <Tooltip title="The destination list where matching rows will be copied. Rows keep their original data. Duplicates (based on email or unique ID) are automatically skipped.">
            <HelpOutline sx={{ fontSize: 16, color: "text.secondary", cursor: "help" }} />
          </Tooltip>
        </Typography>
        <Typography variant="body2">
          Select the list where you want to add the selected rows.
        </Typography>
        <FormControl fullWidth style={{ marginTop: 8 }}>
          <InputLabel>Select List</InputLabel>
          <Select
            label="Select List"
            value={actionParameters.targetListId || ""}
            onChange={(e) =>
              setActionParameters({
                ...actionParameters,
                targetListId: e.target.value,
              })
            }
            disabled={loading}
          >
            <MenuItem value="">
              <em>None</em>
            </MenuItem>
            {lists
              .filter((list) => list.id !== listId)
              .map((list) => (
                <MenuItem key={list.id} value={list.id}>
                  {list.name}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      </div>

      <div style={{ marginTop: "24px" }}>
        <Typography variant="subtitle1" sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
          Remove from Current List
          <Tooltip title="When enabled, this moves rows instead of copying them. The rows will be deleted from this list after being added to the target list.">
            <HelpOutline sx={{ fontSize: 16, color: "text.secondary", cursor: "help" }} />
          </Tooltip>
        </Typography>
        <Typography variant="body2">
          Enable this option to remove the rows from the current list after adding them to the target list.
        </Typography>
        <FormControlLabel
          control={
            <Switch
              checked={actionParameters.removeFromCurrent || false}
              onChange={(e) =>
                setActionParameters({
                  ...actionParameters,
                  removeFromCurrent: e.target.checked,
                })
              }
              color="primary"
            />
          }
          label="Remove from current list after adding"
          style={{ marginTop: "8px" }}
        />
      </div>

      <Typography variant="caption" style={{ marginTop: "16px", display: "block", color: "text.secondary" }}>
        Note: Duplicate rows (based on unique identifiers) will be skipped when adding to the target list.
      </Typography>
    </div>
  );
};